var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

import { isNullOrUndefined } from '@syncfusion/ej2-base';
import { CellRenderer } from './cell-renderer';
import { headerCellInfo } from '../base/constant';
import { setStyleAndAttributes, appendChildren } from '../base/util';
/**
 * StackedHeaderCellRenderer class which responsible for building stacked header cell content.
 * @hidden
 */

var StackedHeaderCellRenderer =
/** @class */
function (_super) {
  __extends(StackedHeaderCellRenderer, _super);

  function StackedHeaderCellRenderer() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.element = _this.parent.createElement('TH', {
      className: 'e-headercell e-stackedheadercell',
      attrs: {
        role: 'columnheader',
        tabindex: '-1'
      }
    });
    return _this;
  }
  /**
   * Function to render the cell content based on Column object.
   * @param  {Column} column
   * @param  {Object} data
   * @param  {Element}
   */


  StackedHeaderCellRenderer.prototype.render = function (cell, data, attributes) {
    var node = this.element.cloneNode();
    var div = this.parent.createElement('div', {
      className: 'e-stackedheadercelldiv',
      attrs: {
        'e-mappinguid': cell.column.uid
      }
    });
    var column = cell.column;
    node.appendChild(div);

    if (!isNullOrUndefined(column.headerTemplate)) {
      appendChildren(div, column.getHeaderTemplate()(column, this.parent, 'headerTemplate'));
    } else {
      this.appendHtml(div, column.headerText, column.getDomSetter());
    }

    if (cell.column.toolTip) {
      node.setAttribute('title', cell.column.toolTip);
    }

    if (column.clipMode === 'Clip' || !column.clipMode && this.parent.clipMode === 'Clip') {
      node.classList.add('e-gridclip');
    } else if (column.clipMode === 'EllipsisWithTooltip' || !column.clipMode && this.parent.clipMode === 'EllipsisWithTooltip') {
      node.classList.add('e-ellipsistooltip');
    }

    if (!isNullOrUndefined(cell.column.textAlign)) {
      div.style.textAlign = cell.column.textAlign;
    }

    if (cell.column.customAttributes) {
      setStyleAndAttributes(node, cell.column.customAttributes);
    }

    node.setAttribute('colspan', cell.colSpan.toString());
    node.setAttribute('aria-colspan', cell.colSpan.toString());
    node.setAttribute('aria-rowspan', '1');

    if (this.parent.allowResizing) {
      var handler = this.parent.createElement('div');
      handler.className = cell.column.allowResizing ? 'e-rhandler e-rcursor' : 'e-rsuppress';
      node.appendChild(handler);
    }

    this.parent.trigger(headerCellInfo, {
      cell: cell,
      node: node
    });
    return node;
  };

  return StackedHeaderCellRenderer;
}(CellRenderer);

export { StackedHeaderCellRenderer };